import EnteteBonEtFacture from '@/components/en-tete-bon-facture';
import DateFilter from '@/components/date-filter';
import ReferenceOperation from '@/components/caisse/reference-operation'
import CaisseInfo from '@/components/caisse/caisse-info'
import $ from 'jquery'
import Vue from 'vue';
import VueHtml2pdf from 'vue-html2pdf'
import store_operation from "@/store/mods/caisse/operations"
Vue.use(VueHtml2pdf)

export default {
    name: 'journal-caisse',
    components: {
        VueHtml2pdf, EnteteBonEtFacture,
        DateFilter, ReferenceOperation, CaisseInfo
    },
    props: [],
    data() {
        return {
            months: [
                { id: '', lib: "Choisir" },
                { id: 1, lib: "Janvier" },
                { id: 2, lib: "Février" },
                { id: 3, lib: "Mars" },
                { id: 4, lib: "Avril" },
                { id: 5, lib: "Mai" },
                { id: 6, lib: "Juin" },
                { id: 7, lib: "Juillet" },
                { id: 8, lib: "Août" },
                { id: 9, lib: "Septembre" },
                { id: 10, lib: "Octobre" },
                { id: 11, lib: "Novembre" },
                { id: 12, lib: "Décembre" },
            ],
            date: new Date(),

            is_empty: false,
            is_loading: true,

            // fields: [
            //     { key: 'ref', label: 'Référence' }, "date", { key: 'user', label: 'Caissier(e)' }, { key: 'libelle', label: 'Libellé' },
            //     "patient", { key: 'qte', label: 'Qté' }, { key: 'pu', label: 'P.U' }, 
            //     { key: 'entree', label: 'Entrées' }, { key: 'sortie', label: 'Sorties' }, 'statut'
            // ],
            fields: [
                { key: 'ref', label: 'Référence' }, "date", { key: 'user', label: 'Caissier(e)' },
                { key: 'libelle', label: 'Libellé' }, "patient", { key: 'qte', label: 'Qté' }, { key: 'pu', label: 'P.U' },  
                { key: 'total', label: 'Total' }, { key: 'coupon', label: 'Coupon' }, { key: 'ba', label: 'BA*' },  
                { key: 'tba', label: 'TBA*' }, { key: 'taux', label: 'Taux' }, 
                { key: 'montant_du', label: 'Mnt dû*' }, { key: 'entree', label: 'Entrées' }, { key: 'sortie', label: 'Sorties' }, 
                { key: 'reste_a_payer', label: 'Rst*' }, 'statut'
            ],
           
            filter: "",
            perPage: -1,
            print_per_page: -1,
            currentPage: 1,
            total_pages: 0,
            filename: '',
            is_printing: false,

            tot_entrees: 0,
            tot_sorties: 0,
            tot_coupon: 0, 
            tot_versement: 0,
            solde: 0,

            rapport_versement: {},

            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            reference_operation: {},
            operation_loading: true,
            operation_isempty: false,
            compte_id: 1,
            op_info: {},
            can_print: false,
            is_month: false,
            personnel_id: "",
            personnel: '',
            operation_filters: [
                { id: 0, libelle: 'Tous', data_type: 'tous', is_op_caisse: 0 }, 
                { id: 1, libelle: 'Payées', data_type: '', is_op_caisse: 1 }, 
                { id: 2, libelle: 'Différées', data_type: '', is_op_caisse: 1 },
                { id: 3, libelle: 'Paiement partiel', data_type: '', is_op_caisse: 1 }, 
                { id: 0, libelle: 'Versement', data_type: 'versement', is_op_caisse: 0 },
                { id: 0, libelle: 'Annulation en attente', data_type: '', is_op_caisse: 2 },
                { id: 0, libelle: 'Annulation accordée', data_type: 'annulation', is_op_caisse: 0 },
                { id: 2, libelle: 'Annulation rejetée', data_type: '', is_op_caisse: 2 },
                { id: 0, libelle: 'Report de reliquat', data_type: 'reliquat', is_op_caisse: 0 },
                { id: 0, libelle: 'Règlement de reliquat', data_type: 'reglement_reliquat', is_op_caisse: 0 },
            ],
            filter_operation: { id: 0, libelle: 'Tous', data_type: 'tous', is_op_caisse: 0 },

            liste_operations: [],
            lop_loading: true,
            lop_empty: false,

            caisse_ops: []
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            this.operations_tobe_canceled = []
            const data = {
                compte_id: this.compte_id,
                user_id: this.personnel_id,
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
                filter_option: this.filter_operation,
                page: 1
            }
            this.current_date_filter = data
            this.is_month = true
            this.getLigneOperationCaisse(data)
            this.getDdayBalance()

            const all_data = {...data}
            all_data.is_paginate = 0
            this.lop_loading = true
            store_operation.selectOperationsCaisse(all_data).then((response) => {
                this.liste_operations = response

                this.lop_loading = false
            })
        },

        personnel() {
            this.personnel_id = this.personnel.id

            this.current_date_filter.user_id = this.personnel_id
            this.current_date_filter.filter_option = this.filter_operation
            this.current_date_filter.page = 1
            this.getLigneOperationCaisse(this.current_date_filter)
            this.getDdayBalance()
            this.getSoldeDisponible()

            const all_data = {...this.current_date_filter}
            all_data.is_paginate = 0
            this.lop_loading = true
            store_operation.selectOperationsCaisse(all_data).then((response) => {
                this.liste_operations = response

                this.lop_loading = false
            })
        },

        filter_operation() {
            this.current_date_filter.filter_option = this.filter_operation
            this.current_date_filter.page = 1
            this.getLigneOperationCaisse(this.current_date_filter)
            this.getDdayBalance()

            const all_data = {...this.current_date_filter}
            all_data.is_paginate = 0
            this.lop_loading = true
            store_operation.selectOperationsCaisse(all_data).then((response) => {
                this.liste_operations = response

                this.lop_loading = false
            })
        }
    },

    computed: {
        solde_disponible() {
            return this.$store.getters["solde_disponible"];
        },

        /**
         * Liste of months of the year [ From january to current month ]
         * @returns 
         */
        monthOfYear() {
            let index;
            var m = []
            for (index = 0; index <= this.date.getMonth() + 1; index++) {
                m[index] = this.months[index];
            }
            return m;
        },

        solde_du_jour() {
            return this.$store.getters["solde_du_jour"];
        },

        liste_personnel_roles() {
            return this.$store.getters["liste_personnel_roles"];
        },
    },

    mounted() {
        if (this.can_set_pac) {
            this.fields = [
                { key: 'ref', label: 'Référence' }, "date", { key: 'user', label: 'Caissier(e)' },
                { key: 'libelle', label: 'Libellé' }, "patient", { key: 'qte', label: 'Qté' }, { key: 'pu', label: 'P.U' },  
                { key: 'total', label: 'Total' }, { key: 'coupon', label: 'Coupon' }, { key: 'pac', label: 'PA*' }, 
                { key: 'total_pac', label: 'TPA*' }, { key: 'ba', label: 'BA*' },  
                { key: 'tba', label: 'TBA*' }, { key: 'taux', label: 'Taux' }, 
                { key: 'montant_du', label: 'Mnt dû*' }, { key: 'entree', label: 'Entrées' }, { key: 'sortie', label: 'Sorties' }, 
                { key: 'reste_a_payer', label: 'Rst*' }, 'statut'
            ]
        } else {
            this.fields = [
                { key: 'ref', label: 'Référence' }, "date", { key: 'user', label: 'Caissier(e)' },
                { key: 'libelle', label: 'Libellé' }, "patient", { key: 'qte', label: 'Qté' }, { key: 'pu', label: 'P.U' },  
                { key: 'total', label: 'Total' }, { key: 'coupon', label: 'Coupon' }, { key: 'ba', label: 'BA*' },  
                { key: 'tba', label: 'TBA*' }, { key: 'taux', label: 'Taux' }, 
                { key: 'montant_du', label: 'Mnt dû*' }, { key: 'entree', label: 'Entrées' }, { key: 'sortie', label: 'Sorties' }, 
                { key: 'reste_a_payer', label: 'Rst*' }, 'statut'
            ]
        }

        const data = {
            compte_id: 1,
            user_id: this.personnel_id,
            month: "",
            one_date: this.setDates().today_date,
            from_date: "",
            to_date: "",
            filter_option: this.filter_operation,
            page: 1
        }
        this.current_date_filter = data
        this.getLigneOperationCaisse(data)
        this.getDdayBalance()

        const all_data = {...data}
        all_data.is_paginate = 0
        store_operation.selectOperationsCaisse(all_data).then((response) => {
            this.liste_operations = response

            this.lop_loading = false
        })

        const tmpstamp = this.date.getHours()+''+this.date.getMinutes()+''+this.date.getFullYear()
        this.filename = 'Journal de caisse_'+tmpstamp

        this.getSoldeDisponible()

        this.$store.dispatch("getRolePersonnels").then(() => {
            const all_user = {
				id: "",
				nom: 'Tous(tes) les caissiers(es)',
                titre: "",
                roles: [],
                email: ""
			}
			this.liste_personnel_roles.unshift(all_user)
        })
    },

    methods: {
        getDdayBalance() {
            this.solde_jour_loading = true
            this.$store.dispatch("getSoldeDuJour", this.current_date_filter).then(() => {
                this.solde_jour = parseInt(this.solde_du_jour);
                this.solde_jour_loading = false
            })
        },

        viewRapport(r) {
            this.rapport_versement = r
        },

        handleViewInfo(operation_info) {
            this.op_info = operation_info

            setTimeout(() => {
                $('.p-partiel-'+operation_info.id).modal('show')
            }, 200);
        },

        resetSoldeOperations() {
            this.tot_entrees = 0
            this.tot_sorties = 0
            this.tot_coupon = 0
        },

        getLigneOperationCaisse(data) {
            this.is_error_load = false
            this.operation_loading = true

            this.resetSoldeOperations()

            store_operation.selectOperationsCaisse(data).then((response) => {
                this.caisse_ops = response
                this.total_pages = response.last_page
                if (this.caisse_ops.data.length > 0) {
                    this.operation_isempty = false
                } else {
                    this.operation_isempty = true
                }
                this.operation_loading = false
            }).catch(() => {
                this.is_error_load = true
                this.operation_loading = false
            })
        },

        filterByDate(date) {
            this.operations_tobe_canceled = []
            const data = {
                compte_id: this.compte_id,
                user_id: this.personnel_id,
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour,
                filter_option: this.filter_operation,
                page: 1
            }
            this.current_date_filter = data
            this.filter_date = ""

            this.is_month = false
            this.getLigneOperationCaisse(data)
            this.getDdayBalance()

            const all_data = {...data}
            all_data.is_paginate = 0
            this.lop_loading = true
            store_operation.selectOperationsCaisse(all_data).then((response) => {
                this.liste_operations = response

                console.log("Stop load 2date");
                this.lop_loading = false
            })
        },

        getSoldeDisponible() {
            this.$store.dispatch("getSoldeDisponible", this.current_date_filter)
        },

        printJournalCaisse() {
            this.can_print = true

            setTimeout(() => {
                
                window.print()
                this.can_print = false
            }, 500);
        },

        viewRef(data) {
            if (data.data_type == 'annulation') {
                this.reference_operation = data.parent
            }

            if (data.etat_annulation == 1) {
                this.reference_operation = data.annulation_associee
            }
        },

        handleViewHistorique(operation_info) {
            this.op_info = operation_info

            setTimeout(() => {
                $('.v-historique-'+operation_info.id).modal('show')
            }, 200);
        },

        previousPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.current_date_filter.page = this.currentPage
                this.getLigneOperationCaisse(this.current_date_filter)
            }
        },

        nextPage() {
            if (this.currentPage < this.total_pages) {
                this.currentPage++;
                this.current_date_filter.page = this.currentPage
                this.getLigneOperationCaisse(this.current_date_filter)
            }
        },

        gotoPage(page) {
            console.log("pg; ",page);
            if (page !== this.currentPage) {
                this.currentPage = page;
                this.current_date_filter.page = this.currentPage
                this.getLigneOperationCaisse(this.current_date_filter)
            }
        },
    }
}


